import {
  HOME_SET_CURRENT_LEAD_BEGIN,
  HOME_SET_CURRENT_LEAD_SUCCESS,
  HOME_SET_CURRENT_LEAD_FAILURE,
  HOME_SET_CURRENT_LEAD_DISMISS_ERROR,
} from './constants'
import _ from 'lodash'
import { BFFAgent } from '../../../common/BFFAgent'

export function setCurrentLead({ id, lead_app } = {}) {
  return (dispatch) => {
    dispatch({
      type: HOME_SET_CURRENT_LEAD_BEGIN,
    })

    const promise = new Promise((resolve, reject) => {
      BFFAgent.Sirena.getCurrentLead(id)
      .then(
        (res) => {
          dispatch({
            type: HOME_SET_CURRENT_LEAD_SUCCESS,
            data: res.data,
            lead_app,
          })
          resolve(res.data)
        },
        (err) => {
          dispatch({
            type: HOME_SET_CURRENT_LEAD_FAILURE,
            data: { error: err },
          })
          reject(err)
        },
      )
    })
    return promise
  }
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissSetCurrentLeadError() {
  return {
    type: HOME_SET_CURRENT_LEAD_DISMISS_ERROR,
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_SET_CURRENT_LEAD_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        setCurrentLeadPending: true,
        setCurrentLeadError: null,
        client_lead: null,
        client_lead_app: null,
      }

    case HOME_SET_CURRENT_LEAD_SUCCESS:
      // The request is success
      return {
        ...state,
        setCurrentLeadPending: false,
        setCurrentLeadError: null,
        client_lead: action.data,
        client_lead_app: action.lead_app,
        client_lead_cleared: state.client_lead
          ? _.uniqBy([state.client_lead].concat(state.client_lead_cleared), 'id').slice(0, 5)
          : state.client_lead_cleared,
      }

    case HOME_SET_CURRENT_LEAD_FAILURE:
      // The request is failed
      return {
        ...state,
        setCurrentLeadPending: false,
        setCurrentLeadError: action.data.error,
        client_lead: null,
        client_lead_app: null,
      }

    case HOME_SET_CURRENT_LEAD_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        setCurrentLeadError: null,
      }

    default:
      return state
  }
}
